import { SimpleSwitchField } from "containers/Resources/screens/ResourcesSingle/components/ResourceDetails/SimpleSwitchField";

export const ForceTrackInGitField = ({
    defaultValue,
    initialValue,
    onChange,
    label,
    isDisabled,
}: {
    onChange?: (e?: any) => void;
    defaultValue?: boolean;
    initialValue?: boolean;
    label?: string;
    isDisabled?: boolean;
}) => (
    <SimpleSwitchField
        name="force_track_in_git"
        defaultValue={defaultValue}
        initialValue={initialValue}
        onChange={onChange}
        label={label}
        isDisabled={isDisabled}
        docs={{
            text:
                "Records in this project or bundle are always tracked in git: the backend forces " +
                "track_in_git=true even when a request sets it false, and it cannot be " +
                "overridden per record. Applies as records are created or changed; it does " +
                "not retroactively re-track records that already exist.",
            urlPath: "/docs/git-integration#force-track-in-git",
        }}
    />
);
